import api from "./api";

export function getPartTimeJobPage(country_id) {
  return api.get(`/jobpage/${country_id}`);
}
